module.exports = __webpack_public_path__ + "static/ensemble-7e1ae14ef905cf3e76443a9b76e5178b.jpg";